'use client'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useState } from 'react'

export function QueryProvider({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // With SSR, we should set staleTime to avoid immediate refetch on client
            staleTime: 60 * 1000, // 1 minute
            gcTime: 60 * 1000,
            refetchOnWindowFocus: false,
            retry: 0,
          },
        },
      })
  )

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* <ReactQueryDevtools
        initialIsOpen={false}
        position='left'
        buttonPosition='bottom-left'
      /> */}
    </QueryClientProvider>
  )
}
